<template>
  <div>
    <b-input-group>
      <b-input
        type="text"
        :state="state"
        :disabled="disabled || loading"
        v-mask="'#####-###'"
        v-model="cep"
        @input="evOnCEPInput"
        @change="evOnCEPChange"
      />
      <b-form-invalid-feedback> CEP inválido </b-form-invalid-feedback>
    </b-input-group>
    <SearchCEP @selected="evOnSearchSelected" />
  </div>
</template>

<script>
import SearchCEP from "./SearchCEP.vue";
import apiCep from "../../services/apiCep";

export default {
  name: "BInputCEP",

  components: {
    SearchCEP,
  },

  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      loading: false,
      state: null,
      cep: "",
    };
  },

  created() {
    if (typeof this.value === "string") this.cep = this.value;
    else this.cep = "";
  },

  watch: {
    value() {
      if (typeof this.value === "string") this.cep = this.value;
      else this.cep = "";
      this.retrieve(false);
    },
  },

  methods: {
    async evOnCEPInput(value) {
      this.$emit("input", value);
    },

    async evOnCEPChange(value) {
      this.$emit("change", value);
      this.retrieve();
    },

    retrieve(emit = true) {
      if (this.cep.length === 0) {
        this.state = null;
        return;
      }

      if (!this.cep.match(/^\d{5}-\d{3}$/)) {
        this.state = false;
        return;
      }

      this.loading = true;
      apiCep
        .get(`/${this.cep}/json`)
        .then((response) => {
          /**
           * @type {{
           *   error: boolean,
           *   cep: string,
           *   logradouro: string,
           *   complemento: string,
           *   bairro: string,
           *   localidade: string,
           *   uf string,
           *   ibge: string,
           *   gia: string,
           *   ddd: string,
           *   siafi: string,
           * }}
           *
           */
          const data = response.data;
          const { erro, cep, logradouro, complemento, bairro, localidade, uf } =
            data;

          if (erro) {
            this.state = false;
          } else {
            this.state = null;

            if (emit) {
              this.$emit("retrieved", {
                cep,
                logradouro,
                complemento,
                bairro,
                localidade,
                uf,
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    evOnSearchSelected(value) {
      this.cep = value.cep;
      this.$emit("retrieved", value);
    },
  },
};
</script>

<style>
</style>
